import React, { Suspense, lazy } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import ProtectedRouting from "../src/components/ProtectedRoute/ProtectedRoute.jsx";
import PageNotFound from "./pages/pageNotFound/PageNotFound.jsx";
import Demo from "./components/Demo.js";
import Dashboardpage from "./pages/Dashboardpage/Dashboardpage.jsx";
import ProPartnerAnalytics from "./components/ProPartner/ProPatnerAnalytics.js";
import ProPartnerUsers from "./components/ProPartner/ProPartnerUsers.js";
import ProPartnerPayOuts from "./components/ProPartner/ProPartnerPayOuts.js";
import ProPartnerWithDrawAmount from "./components/ProPartner/ProPartnerWithDrawAmount.js";
import CCInstantPay from "./pages/BBPS/CCInstantPay.js";
import InstantBbps from "./pages/BBPS/InstantBbps.jsx";
import BillAvenueBbps from "./pages/BBPS/BillAvenueBbps.jsx";
import InstantBbpsPayPage from "./pages/BBPS/InstantBbpsPayPage.jsx";
import CreditCardInstantBbps from "./pages/CreditCardBillPayments/CreditCardInstantBbps.jsx";
import CreditCardInstantPay from "./pages/CreditCardBillPayments/CreditCardInstantPay.jsx";
import AddtutorFlow from "./pages/Education/Addtutor.jsx";
import EducationPay from "./pages/Education/cardUserScreen.jsx";
import EducationPaycheckout from "./pages/Education/checkOut.jsx";

// Loading component
const LoadingFallback = () => (
  <div
    className="d-flex justify-content-center align-items-center"
    style={{ height: "100vh" }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

// Lazy loaded components
const Analytics = lazy(() => import("./pages/Analytics/Analytics.js"));
const Users = lazy(() => import("./pages/Users/Users.js"));
const Payouts = lazy(() => import("./pages/Payouts/Payouts.js"));
const AccountDetails = lazy(
  () => import("./pages/AccountDetails/AccountDetails.js"),
);
const ProfileDetails = lazy(
  () => import("./pages/ProfileDetails/ProfileDetails.js"),
);
const BbpsPage = lazy(() => import("./pages/BBPS/Bbps"));
const Loginpage = lazy(() => import("./pages/login/login"));
const BBPSServices = lazy(() => import("./components/BBPS/BBPSServices"));
const GetPaid = lazy(() => import("./components/GetPaid/GetPaid"));
const BBPSHelp = lazy(() => import("./pages/BBPSHelp/BBPSHelp"));
const RaisingComplaint = lazy(
  () => import("./pages/RaisingComplaint/RaisingComplaint"),
);
const HelpComponent = lazy(
  () => import("./components/HelpComponent/HelpComponent"),
);
const ViewComplaint = lazy(() => import("./pages/ViewComplaint/ViewComplaint"));
const History = lazy(() => import("./pages/History/History.jsx"));
const HelpandSupport = lazy(
  () => import("./pages/supportAndContact/HelpandSupport.jsx"),
);
const RaiseTicket = lazy(
  () => import("./components/RaiseTicket/RaiseTicket.jsx"),
);
const Ticket = lazy(() => import("./components/Ticket/Ticket.jsx"));
const PayService = lazy(() => import("./pages/PayService/PayService.jsx"));
const ContactDetails = lazy(
  () => import("./pages/PayserviceContactdetails/ContactDetails.jsx"),
);
const PaymentModal = lazy(
  () => import("./components/PaymentModal/PaymentModal.jsx"),
);
const RazorPayIntegration = lazy(
  () => import("./components/RazorPayIntergration/RazorPayIntegration.jsx"),
);
const ComplaintReplyScreen = lazy(
  () => import("./pages/ComplaintReplyScreen/ComplaintReplyScreen.jsx"),
);
const CashfreeSuccessfull = lazy(
  () => import("./components/GetPaid/CashfreeSuccessfull.jsx"),
);
const WalletBalance = lazy(
  () => import("./components/WalletBalance/WalletBalance.jsx"),
);
const PaymentLinks = lazy(
  () => import("./pages/PaymentLinks/PaymentLinks.jsx"),
);
const ActiveQR = lazy(() => import("./pages/ActiveQR/ActiveQR.js"));
const PayRent = lazy(() => import("./pages/PayRent/PayRent.js"));
const PaymentLinkMain = lazy(
  () => import("./pages/PaymentLinks/PaymentLinkMain.jsx"),
);
const EnterAmount = lazy(() => import("./pages/CreateLink/EnterAmount.jsx"));
const EnterDetails = lazy(() => import("./pages/CreateLink/EnterDetails.jsx"));
const LinkShow = lazy(() => import("./pages/CreateLink/LinkShow.jsx"));
const CustomPayModel = lazy(
  () => import("./pages/CustomPayModel/CustomPayModel.jsx"),
);
const CustomePaymentLinks = lazy(
  () => import("./components/CustomPaymentLinks/CustomePaymentLinks.jsx"),
);
const PaymentDetails = lazy(
  () => import("./pages/CustomPayModel/PaymentDetails.jsx"),
);
const AddingCreditCard = lazy(
  () => import("./pages/CustomPayModel/AddingCreditCard.jsx"),
);
const PaymentMethod = lazy(
  () => import("./pages/PaymentMethod/PaymentMethod.js"),
);
const TimerPay = lazy(() => import("./components/TimerPay/TimerPay.js"));
const Pos = lazy(() => import("./pages/Pos/Pos.js"));
const PaywithCreditCard = lazy(
  () => import("./components/PaywithCreditCard/PaywithCreditCard.js"),
);
const AddingAmountWallet = lazy(
  () => import("./components/GetPaid/AddingAmountWallet.jsx"),
);
const CustomPayModelMain = lazy(
  () => import("./pages/CustomPayModel/CustomPayModelMain.jsx"),
);
const PaymentMethods = lazy(
  () => import("./components/CustomPaymentLinks/PaymentMethods.jsx"),
);
const CreditCardPayment = lazy(
  () => import("./components/CustomPaymentLinks/CreditCardPayment.jsx"),
);
const CreditCardBillPayments = lazy(
  () => import("./pages/CreditCardBillPayments/CreditCardBillPayments.js"),
);
const WithDrawAmount = lazy(
  () => import("./pages/WithDrawAmount/WithDrawAmount.js"),
);
const Footer = lazy(() => import("./components/Footer/Footer.jsx"));
const SettlementsNew = lazy(
  () => import("./pages/SettlementsNew/SettlementsNew.js"),
);
const SettlementDetails = lazy(
  () => import("./pages/SettlementDetails/SettlementDetails.js"),
);
const CreditCardPaymentPay = lazy(
  () => import("./pages/CreditCardPaymentPay/CreditCardPaymentPay.js"),
);
const PayOutWay = lazy(
  () => import("./pages/PayserviceContactdetails/PayOutWay.jsx"),
);
const CreditCardEnterAmount = lazy(
  () => import("./pages/CreditCardBillPayments/CreditcardEnteramount.jsx"),
);
const MobilePrepaid = lazy(
  () => import("./pages/BBPS/MobilePrepaid/mobilePrepaid.jsx"),
);
const MobilePrepaidPayment = lazy(
  () => import("./pages/BBPS/MobilePrepaid/mobilePrepaidPayment.jsx"),
);
const Header = lazy(() => import("./components/Header/Header.js"));
const RazorPaySuccessfull = lazy(
  () => import("./components/GetPaid/RazorPaySuccessfull.jsx"),
);
const NewReceipt = lazy(() => import("./components/NewReceipt/Receipt.js"));
const CashfreeWebViewSuccessfull = lazy(
  () => import("./components/GetPaid/CashfreeWebViewSuccessfull.jsx"),
);
const CashfreeSeamLessSuccessfull = lazy(
  () => import("./components/GetPaid/CashfreeSeamLessSuccessfull.jsx"),
);
const PaymentLinkReceipt = lazy(
  () => import("./pages/CustomPayModel/PaymentLinkReceipt.jsx"),
);
const SettlementBankDetails = lazy(
  () => import("./pages/SettlementsNew/SettlementBankDetails.js"),
);
const HelpWithQueries = lazy(
  () => import("./components/NewReceipt/HelpWithQueries.js"),
);
const PayUSuccessfull = lazy(
  () => import("./components/GetPaid/PayUSuccessfull.js"),
);
const UpiIdStatusScreen = lazy(
  () => import("./pages/CreditCardPaymentPay/UpiIdStatusScreen.jsx"),
);
const BbpsCardPayments = lazy(
  () => import("./pages/PaymentMethod/BbpsCardPayments.jsx"),
);
const Ferry_LocationSearch = lazy(
  () => import("./pages/FerryBooking/Ferry_LocationSearch.jsx"),
);
const FerryList = lazy(() => import("./pages/FerryBooking/FerryList.jsx"));
const Ferry_SeatSelection = lazy(
  () => import("./pages/FerryBooking/Ferry_SeatSelection.jsx"),
);
const Ferry_PassengerDetails = lazy(
  () => import("./pages/FerryBooking/Ferry_PassengerDetails.jsx"),
);
const Ferry_Pdf = lazy(() => import("./pages/FerryBooking/Ferry_Pdf"));
const EducationSelection = lazy(
  () => import("./pages/Education/EducationSelection.jsx"),
);
const ProfileView = lazy(() => import("./pages/Education/ProfileView.jsx"));
const EducationHistory = lazy(
  () => import("./pages/Education/EducationHistory.jsx"),
);
const EducationAmountConfirmPage = lazy(
  () =>
    import("./pages/EducationAmountRetrival/EducationAmountConfirmPage.jsx"),
);


const MainRouter = () => {
  const navigation = useNavigate();

  // document.addEventListener("contextmenu", function (e) {
  //   e.preventDefault();
  // });
  // document.addEventListener("keydown", function (e) {
  //   if (
  //     e.key === "F12" ||
  //     (e.ctrlKey && e.shiftKey && e.key === "I") ||
  //     (e.ctrlKey && e.shiftKey && e.key === "J") ||
  //     (e.ctrlKey && e.shiftKey && e.key === "C") ||
  //     (e.ctrlKey && e.shiftKey && e.key === "P") ||
  //     e.key === "F12"
  //   ) {
  //     e.preventDefault();
  //   }
  // });

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* ✅ Protected Routes inside Demo */}
        <Route element={<ProtectedRouting />}>
          <Route path="/" element={<Demo />}>
            <Route index element={<Dashboardpage />} />
            <Route path="/PaywithCreditCard" element={<PaywithCreditCard />} />
            <Route path="/bbps" element={<BBPSServices />} />
            <Route path="bbps/Mobile Prepaid" element={<MobilePrepaid />} />
            <Route
              path="bbps/Mobile Prepaid/Pay"
              element={<MobilePrepaidPayment />}
            />
            <Route path="bbps/:operators" element={<BbpsPage />} />
            <Route path="/WalletBalance" element={<WalletBalance />} />
            <Route path="/History" element={<History />} />
            <Route path="/Settlement" element={<SettlementsNew />} />
            <Route path="/SettlementDetails" element={<SettlementDetails />} />
            <Route path="/HelpWithQueries" element={<HelpWithQueries />} />
            <Route
              path="/CreditCardPaymentPay"
              element={<CreditCardPaymentPay />}
            />
            <Route
              path="/CreditCardBillPayments"
              element={<CreditCardBillPayments />}
            />
            <Route
              path="/CreditCardInstantPay"
              element={<CreditCardInstantPay />}
            />
            <Route
              path="/CreditCardInstantBbps"
              element={<CreditCardInstantBbps />}
            />
            <Route
              path="/ProPartnerAnalytics"
              element={<ProPartnerAnalytics />}
            />
            <Route path="/ProPartnerUsers" element={<ProPartnerUsers />} />
            <Route path="/ProPartnerPayouts" element={<ProPartnerPayOuts />} />
            <Route
              path="/Ferry_LocationSearch"
              element={<Ferry_LocationSearch />}
            />
            <Route path="/FerryList" element={<FerryList />} />
            <Route
              path="/Ferry_PassengerDetails"
              element={<Ferry_PassengerDetails />}
            />
            <Route path="/Ferry_Pdf" element={<Ferry_Pdf />} />
            <Route
              path="/ProPartnerWithDrawAmount"
              element={<ProPartnerWithDrawAmount />}
            />
            <Route path="/WithDrawAmount" element={<WithDrawAmount />} />
            <Route path="/PayService" element={<PayService />} />
            <Route path="/PaymentLinks" element={<PaymentLinkMain />}>
              <Route index element={<PaymentLinks />} />
              <Route path="enter" element={<EnterAmount />} />
              <Route path="details" element={<EnterDetails />} />
              <Route path="linkShow" element={<LinkShow />} />
            </Route>
            <Route path="/ActiveQR" element={<ActiveQR />} />
            <Route path="/Analytics" element={<Analytics />} />
            <Route path="/Users" element={<Users />} />
            <Route path="/Payouts" element={<Payouts />} />
            <Route path="/AccountDetails" element={<AccountDetails />} />
            <Route path="/ProfileDetails" element={<ProfileDetails />} />
            <Route path="/Pos" element={<Pos />} />
            <Route path="/PayRent" element={<PayRent />} />
            <Route path="/PaymentMethod" element={<PaymentMethod />} />
            <Route path="/payOut" element={<PayOutWay />} />
            <Route path="/PaymentModal" element={<PaymentModal />} />
            <Route path="/ContactDetails" element={<ContactDetails />} />
            <Route path="/settlementBank" element={<SettlementBankDetails />} />
            <Route path="/upiIdStatusScreen" element={<UpiIdStatusScreen />} />
            <Route path="/BbpsCardPayments" element={<BbpsCardPayments />} />
            <Route path="/userProfile" element={<ProfileView />} />
            <Route path="/eduHistory" element={<EducationHistory />} />
            <Route
              path="/CreditCardEnterAmount"
              element={<CreditCardEnterAmount />}
            />
            <Route path="/help" element={<HelpComponent />}>
              <Route index element={<BBPSHelp />} />
              <Route path="raise" element={<RaisingComplaint />} />
              <Route path="view" element={<ViewComplaint />} />
            </Route>
            <Route path="/getPaid" element={<GetPaid />} />
            <Route path="/AddAmount" element={<AddingAmountWallet />} />
            <Route path="/support" element={<HelpandSupport />} />
            <Route path="/ticket" element={<RaiseTicket />} />
            <Route path="/Footer" element={<Footer />} />
            <Route path="/NewReceipt" element={<NewReceipt />} />
            <Route
              path="/ComplaintReplyScreen"
              element={<ComplaintReplyScreen />}
            />
            <Route path="/AddtutorFlow" element={<AddtutorFlow />} />
            <Route path="/EducationPay" element={<EducationPay />} />
            <Route
              path="/EducationPaycheckout"
              element={<EducationPaycheckout />}
            />
            <Route path="/AddtutorFlow" element={<AddtutorFlow />} />
            <Route path="/EducationPay" element={<EducationPay />} />
            <Route path="/eduSelect" element={<EducationSelection />} />
            <Route path="/showTicket" element={<Ticket />} />
            {/* <Route path="/dashboardpage" element={<Dashboardpage />} /> */}
            <Route
              path="/profile"
              element={
                <div
                  style={{ height: "50vh" }}
                  className="align-content-center"
                >
                  <b className="text-dark">Coming Soon!</b>
                  <br />
                  <button
                    className="btn"
                    style={{ backgroundColor: "var(--secondshade-orange)" }}
                    onClick={() => navigation("/bbps")}
                  >
                    Notify Me
                  </button>
                </div>
              }
            />
            <Route
              path="/settings"
              element={
                <div
                  style={{ height: "50vh" }}
                  className="align-content-center"
                >
                  <b className="text-dark">Coming Soon!</b>
                  <br />
                  <button
                    className="btn"
                    style={{ backgroundColor: "var(--secondshade-orange)" }}
                    onClick={() => navigation("/bbps")}
                  >
                    Notify Me
                  </button>
                </div>
              }
            />
            <Route path="/payInstantDetails" element={<CCInstantPay />} />
            <Route
              path="/cashfree/integration/Status"
              element={<CashfreeSuccessfull />}
            />
            <Route
              path="/cashfreeWebView/integration/Status"
              element={<CashfreeWebViewSuccessfull />}
            />
            <Route
              path="/cashfreeSeamless/integration/Status"
              element={<CashfreeSeamLessSuccessfull />}
            />
            <Route
              path="/payu/integration/Status"
              element={<PayUSuccessfull />}
            />
            <Route path="/payScreen" element={<InstantBbps />} />
            <Route path="/enterBbpsDetails" element={<BillAvenueBbps />} />
            <Route path="/payInstant" element={<InstantBbpsPayPage />} />
            <Route path="/razorPay/success" element={<RazorPaySuccessfull />} />
          </Route>
        </Route>
        {/* <Route
          path="/cashfree/integration/Status"
          element={<CashfreeSuccessfull />}
        /> */}
        {/* <Route path="/razorPay/paymentLink/success" element={<RazorPaySuccessfull />} /> */}
        <Route
          path="/Ferry_LocationSearch"
          element={<Ferry_LocationSearch />}
        />
        <Route path="/FerryList" element={<FerryList />} />
        <Route
          path="/Ferry_PassengerDetails"
          element={<Ferry_PassengerDetails />}
        />
        <Route path="/Ferry_Pdf" element={<Ferry_Pdf />} />
        <Route
          path="/cashfreeWebView/integration/paymentLink/Status"
          element={<CashfreeWebViewSuccessfull />}
        />
        <Route
          path="/cashfreeSeamless/integration/paymentLink/Status"
          element={<CashfreeSeamLessSuccessfull />}
        />
        <Route
          path="/payu/integration/paymentLink/Status"
          element={<PayUSuccessfull />}
        />
         <Route
          path="/paymentConsent/:id"
          element={<EducationAmountConfirmPage />}
        />
        <Route path="/NPL/:MerchantId" element={<CustomPayModelMain />}>
          <Route index element={<CustomPayModel />} />
          <Route path="payDetails" element={<PaymentDetails />} />
          <Route path="card" element={<AddingCreditCard />} />
          <Route path="PayLinkReceipt" element={<PaymentLinkReceipt />} />
        </Route>
        <Route path="/login" element={<Loginpage />} />
        <Route path="/pay/:linkid" element={<CustomePaymentLinks />} />
        <Route path="/payMethod" element={<PaymentMethods />} />
        <Route path="/cerditPay" element={<CreditCardPayment />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/Header" element={<Header />} />
      </Routes>
    </Suspense>
  );
};

export default MainRouter;
